import {Button, Card, Col, Row, Spinner} from "reactstrap";
import {InfoPageMessage} from "../../Common/Components/Button/InfoPageMessage";
import React, {useEffect, useRef, useState} from "react";
import DragAndDrop from "../../Common/Components/Lists/DragAndDrop";
import {CustomModal} from "../../Common/Components/Modal/CustomModal";
import {ToCustomDecimal} from "../../AppSystem/Helpers/ToCustomDecimal";
import {useTranslation} from "react-i18next";
import RequestClient from "../Models/Request/RequestClient";
import {CustomInput} from "../../Common/Components/Input/CustomInput";
import {CustomSubmitButton} from "../../Common/Components/Input/CustomSubmitButton";
import RequestInvoice from "../Models/Request/RequestInvoice";
import CostBearerModel from "../../CostBearer/Models/Response/CostBearerModel";
import useApiCallService from "../../Common/Helpers/ApiCall";
import {ChangeDateFormat} from "../../Common/Helpers/ChangeDateFormat";
import {CheckDecimal} from "../../Common/Helpers/CheckDecimal";
import {CustomButton} from "../../Common/Components/Button/CustomButton";
import RequestInvoiceRow from "../Models/Request/RequestInvoiceRow";
import AccountingAccountModel from "../../Accounting/Models/Response/ResponseAccountingAccountModel";
import $ from "jquery";
import {FlashMessage} from "../../Common/Helpers/FlashMessage";
import {CustomReload} from "../../AppSystem/Helpers/CustomReload";
import {ORGANIZATION_PATHS} from "../../config";
import {ClearEmptyJson} from "../../AppSystem/Helpers/ClearEmptyJson";
import {useNavigate} from "react-router-dom";
import {generateFileName} from "../../AppSystem/Helpers/GenerateFileName";
import {CheckUserPermission} from "../../AppSystem/Helpers/CheckUserPermission";
import {InputMessage} from "../../AppSystem/Helpers/InputMessage";
import { useSelector } from "react-redux";
import {CheckMobile} from "../../AppSystem/Helpers/CheckMobile";
import { VatManagementModal } from './VatManagementModal';
import { CheckUserRole } from "../../AppSystem/Helpers/CheckUserRole";
import { useHeader } from "../../Auth/Components/Nav/HeaderContext";

export function InvoiceCreate() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { ApiCall } = useApiCallService();
    const {rolesData, userData, orgData } = useSelector(state => state.auth);
    const [apiResponseOrgInfo, setApiResponseOrgInfo] = useState(null);
   // const [errorPrice, setErrorPrice] = useState(false);
   // const [indexRow, setIndexRow] = useState('');
    const windowWidth = CheckMobile(998);
    const { setPageTitle, setPageTitleKey, setOnBack } = useHeader();

    useEffect(() => {
        setPageTitle(t('invoice.createInvoice'));
            setPageTitleKey('invoice.createInvoice');
        setOnBack(() => navigate(ORGANIZATION_PATHS.INVOICE_LIST));
        return () => { setPageTitle(''); setPageTitleKey(''); setOnBack(null); };
    }, [t]);

    const isAdmin = CheckUserRole(rolesData, 'Admin');

    // REQUEST
    const [requestCreateNewClient, setRequestCreateNewClient] = useState(new RequestClient());
    const [requestCreateInvoice, setRequestCreateInvoice] = useState(new RequestInvoice());
    const [idClient, setIdClient] = useState(null);
    const [getClient, setGetClient] = useState(null);
    const [visualId, setVisualId] = useState(null);


    //RESPONSE
    const [responseCreateNewClient, setResponseCreateNewClient] = useState('');
    const [responseCreateInvoice, setResponseCreateInvoice] = useState(null);

    const [items, setItems] = useState([ {id: '1', content: new RequestInvoiceRow()}]);

    // MODAL OPTIONS
    const [displayAddNewClientModal, setDisplayAddNewClientModal] = useState(false);

    // COST BEARER
    const [costResponse, setCostResponse] = useState(null);
    const [costSelected, setCostSelected] = useState(null);

    // ACCOUNTING RESPONSES
    const [accountingResponse, setAccountingResponse] = useState(null);

    //CLIENT
    const [clientListResponse, setClientListResponse] = useState(null);

    const [productsTotalAmount, setProductsTotalAmount] = useState('');

    //VALIDATION SCHEMAS
    const completeSchemaClient = RequestClient.getAttributes( null, true);
    const completeSchemaInvoice = RequestInvoice.getAttributes( null, true);
    const completeSchemaRows = RequestInvoiceRow.getAttributes(null, true);
    //const completeSchemaRowsSend = RequestInvoiceRow.getAttributes( null, null, true);

    // SPINNER
    const [displaySpinner, setDisplaySpinner] = useState(false);
    const [displaySpinnerClient, setDisplaySpinnerClient] = useState(false);

    const [productsResponse, setProductsResponse] = useState([]);

    const [isSave, setIsSave] = useState(false);

    //CHECK MOUSE OVER
    const [isMouseOver, setIsMouseOver] = useState(false);

    //PDF
    const [previewPdf, setPreviewPdf] = useState(null);

    //REF
    const formDivRefClient = useRef(null);
    const formDivRefInvoice = useRef(null);

    const [isDisabled, setIsDisabled] = useState(true);

    const messageCostBearer = InputMessage(costResponse, requestCreateInvoice.costBearerId);

    let permissionCreate = false;
    if (CheckUserPermission("org.collect.client.create") || CheckUserPermission("org.collect.client") || CheckUserPermission("org.collect") || CheckUserPermission("org")) {
        permissionCreate = true;
    }
    let permissionViewClient = false;
    if (CheckUserPermission("org.collect.client.view") || CheckUserPermission("org.collect.client") || CheckUserPermission("org.collect") || CheckUserPermission("org")) {
        permissionViewClient = true;
    }
    let permissionCreateInvoice = false;
    if (CheckUserPermission("org.collect.invoice.view") || CheckUserPermission("org.collect.invoice") || CheckUserPermission("org.collect") || CheckUserPermission("org")) {
        permissionCreateInvoice = true;
    }

    const handleMouseEnter = () => {
        setIsMouseOver(true);
    };

    const handleMouseLeave = () => {
        setIsMouseOver(false);
    };

    useEffect(() => {

        const handleApiResponseGetOrgUser  = (apiResponseOrgInfo) => {
            setApiResponseOrgInfo(apiResponseOrgInfo);

        };
        const GetOrgUser = async () => {
            try {
                const apiCallOptions = {
                    method: "get",
                    url: "/org/list-dropdown?orgId=" + orgData.orgId,
                };

                await ApiCall(apiCallOptions, handleApiResponseGetOrgUser );

            } catch (error) {
                console.log('error', error);
            }
        };

        GetOrgUser();

    }, []);

    // API CALL TO GET VAT PRODUCTS
    useEffect(() => {
        const handleProductsResponse = (productsResponse) => {
            setProductsResponse(productsResponse);
        };
        const ProductsApiCall = async () => {
            try {
                const apiCallOptions = {
                    method: "get",
                    url: "/invoice/vat/list",
                };
                await ApiCall(apiCallOptions, handleProductsResponse);
            } catch (error) {
                console.log('error', error);
            }
        };
        ProductsApiCall();
    }, []);

    let productJson = {};
    if (productsResponse !== null) {
        const productArray = [];
        productsResponse?.forEach((item) => {
            const label = [
                item.name,
                item.accounting ? `(${item.accounting})` : null,
                item.momsfritt ? '(Momsfritt)' : null,
            ].filter(Boolean).join(' ');

            productArray.push({
                ...item,
                label: label,
            });
        });
        productJson = {
            product: productArray
        };
    }

    const findProductByReference = (productReference) => {
        if (!productReference || !Array.isArray(productsResponse)) {
            return null;
        }

        const stringReference = String(productReference);
        return productsResponse.find((item) => String(item.id) === stringReference || item.name === productReference) ?? null;
    };

    // API CALL TO GET COST BEARER
    useEffect(() => {
        const handleCostResponse = (costResponse) => {
            setCostResponse(costResponse);
        };
        const CostApiCall = async () => {
            try {
                const apiCallOptions = {
                    method: "get",
                    url: "/costbearer/list-org?id=" + orgData.orgId,
                };
                await ApiCall(apiCallOptions, handleCostResponse);
            } catch (error) {
                console.log('error', error);
            }
        };
        CostApiCall();
    }, []);

    // API CALL TO GET ACCOUNTING
    useEffect(() => {
        const handleAccountingResponse  = (accountingResponse) => {
            setAccountingResponse(accountingResponse);
        };
        const AccountingApiCall = async () => {
            try {
                const apiCallOptions = {
                    method: "get",
                    url: "/accounting/list",
                };
                await ApiCall(apiCallOptions, handleAccountingResponse);
            } catch (error) {
                console.log('error', error);
            }
        };
        AccountingApiCall();
    }, []);

    let costJson = {};
    if (costResponse !== null) {
        const costBearerArray = [];
        costResponse.forEach((item) => {
            const cosBearerModel = new CostBearerModel(item);
            costBearerArray.push(cosBearerModel);
        });
        costJson = {
            costBearer: costBearerArray
        };
    }

    let accountingJson = {};
    if (accountingResponse !== null) {
        const accountingArray = [];
        accountingResponse.forEach((item) => {
            const accountingModel = new AccountingAccountModel(item);
            accountingArray.push(accountingModel);
        });
        accountingJson = {
            accounting: accountingArray,
        };
    }

    // CLIENT SEARCH
    useEffect(() => {
        const handleClientListResponse = (response) => {
            if ( response !== null) {
                setClientListResponse(response.items);
            }
        };
        const ClientApiCall = async () => {
            try {
                const apiCallOptions = {
                    method: "get",
                    url: "/client/search?perpage=1000",
                };
                await ApiCall(apiCallOptions, handleClientListResponse);
            } catch (error) {
                console.log('error', error);
            }
        };
        ClientApiCall();
    }, [/*responseCreateNewClient*/]);

    let clientJson = {};
    if (clientListResponse !== null) {
        const clientArray = [];
        clientListResponse?.forEach((item) => {
            clientArray.push(item);
        });
        clientJson = {
            client: clientArray
        };
    }

    // GET ID IF EXISTS FOR DRAFT MODE
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id') ?? "";

    // GET INVOICE FOR DRAFT MODE
    useEffect(() => {
        if (id !== "") {
            const handleDraftResponse = (response) => {
                if (response !== null) {
                    setRequestCreateInvoice(new RequestInvoice(response));
                    setVisualId(response.visualId);
                    setIdClient(response.clientId);
                    if (response.rows && response.rows.length > 0) {
                        const newItems = response.rows.map((value, index) => {
                            const foundProduct = findProductByReference(value.product);
                            let vatRate = value.vatRate ?? foundProduct?.vatValue ?? 0;
                            const quantity = Number(value.quantity ?? 1);
                            const price = Number(value.price ?? 0);
                            const vatAmount = value.vatAmount ?? (price * quantity * vatRate / 100);
                            
                            return {
                                id: (index + 1).toString(),
                                content: {
                                    ...value,
                                    product: foundProduct?.id != null ? String(foundProduct.id) : value.product,
                                    vatRate: vatRate,
                                    vatAmount: vatAmount,
                                }
                            };
                        });

                        setItems(newItems);
                    }
                }
            }
            const fetchData = async () => {
                try {
                    const apiCallOptions = {
                        method: "get",
                        url: `/invoice?id=${id}`
                    };
                    await ApiCall(apiCallOptions, handleDraftResponse);
                } catch (error) {
                    console.log('error', error);
                }
            };
            fetchData();
        }
    }, [id, productsResponse]);

    // Backfill VAT/accounting and normalize product references when product catalog arrives later.
    useEffect(() => {
        if (!Array.isArray(productsResponse) || productsResponse.length === 0 || !Array.isArray(items) || items.length === 0) {
            return;
        }

        let hasChanges = false;
        const syncedItems = items.map((item) => {
            const productReference = item.content?.product;
            if (!productReference) {
                return item;
            }

            const selectedProduct = findProductByReference(productReference);
            if (!selectedProduct) {
                return item;
            }

            const quantity = Number(item.content?.quantity ?? 1);
            const price = Number(item.content?.price ?? 0);
            const nextVatRate = Number(selectedProduct.vatValue ?? 0);
            const nextVatAmount = price * quantity * nextVatRate / 100;
            const nextProductReference = selectedProduct.id != null ? String(selectedProduct.id) : item.content.product;
            const nextAccountingValue = selectedProduct.accounting ?? "";

            const currentVatRate = Number(item.content?.vatRate ?? 0);
            const currentVatAmount = Number(item.content?.vatAmount ?? 0);
            const currentProductReference = item.content?.product;
            const currentAccountingValue = item.content?.accountingValue ?? "";

            if (
                currentVatRate !== nextVatRate ||
                currentVatAmount !== nextVatAmount ||
                String(currentProductReference) !== String(nextProductReference) ||
                currentAccountingValue !== nextAccountingValue
            ) {
                hasChanges = true;
                return {
                    ...item,
                    content: {
                        ...item.content,
                        product: nextProductReference,
                        vatRate: nextVatRate,
                        vatAmount: nextVatAmount,
                        accountingValue: nextAccountingValue,
                    }
                };
            }

            return item;
        });

        if (hasChanges) {
            setItems(syncedItems);
        }
    }, [productsResponse, items]);

    //TOTAL VALUES AMOUNT
    useEffect(() => {
        if(items) {
            const amounts =  items.map((value) => {
                if(value.content.quantity === undefined) {
                    value.content.quantity = 1;
                }
                if(value.content.price === undefined) {
                    value.content.price = 0;
                }
                let productAmount = value.content.quantity * value.content.price;
                return productAmount !== 0 ? productAmount : null;
            }).filter(amount => amount !== null);

            const total= amounts.reduce((acc, curr) => acc + curr, 0);
            const totalVatAmount = items.reduce((acc, item) => {
                const vatAmount = item.content.vatAmount ? parseFloat(item.content.vatAmount) : 0;
                return acc + vatAmount;
            }, 0);

            const totalAmount = total + totalVatAmount;

            setProductsTotalAmount ((prevData) => ({
                ...prevData,
                amount: total,
                vatAmount: totalVatAmount,
                totalAmount: totalAmount,
            }))
        }
    }, [items]);

    const handleDragEnd = ({ reorderedItems  }) => {
        setItems(reorderedItems);
    };


    const HandleChangeInvoiceRow = (e, name, id) => {
        setIsDisabled(true);
        $("#buttonPreview").prop("disabled", true);
    
        const index = items.findIndex(item => item.id === id);
        let accountingValue = items[index].content.accountingValue ?? "";
        let product = items[index].content.product ?? "";
        let productName = items[index].content.name ?? "";
        let quantity = items[index].content.quantity ?? 1;
        let price = items[index].content.price ?? 0;
        let vatAmount = items[index].content.vatAmount ?? 0;
        let vatRate = items[index].content.vatRate ?? 0;

        if (name === "product") {
            const selectedProduct = findProductByReference(e.target.value);
            product = e.target.value;
            vatRate = selectedProduct?.vatValue ?? 0;
            
            // Recalculate VAT when product changes (id-based reference).
            vatAmount = Number(price) * Number(quantity) * vatRate / 100;
            
            // GET ACCOUNTING ID FROM SELECTED PRODUCT
            accountingValue = selectedProduct?.accounting ?? "";
        }
        if (name === "name") {
            productName = e.target.value;
        }
        if (name === "quantity") {
            if (e && e.target && e.target.value !== "") {
                quantity = CheckDecimal(e.target.value);
            } else {
                quantity = 1;
            }
            vatAmount = Number(price) * Number(quantity) * vatRate / 100;
        }
        if (name === "price") {
            if (e && e.target && e.target.value !== "") {
                price = CheckDecimal(e.target.value);
               // setErrorPrice(false)
                /*let stringIndex = String(index + 1);
                setIndexRow(stringIndex);*/
            } else {
                price = 0;
                /*let stringIndex = String(index + 1);
                setIndexRow(stringIndex);*/

            }
            vatAmount = Number(price) * Number(quantity) * vatRate / 100;
        }

        let newContent = {
            accountingValue: accountingValue,
            product: product,
            name: productName,
            quantity: quantity,
            price: price,
            vatAmount: vatAmount,
            vatRate: vatRate
        };

        const updatedItems = items.map(item =>
            item.id === id ? { ...item, content: newContent } : item
        );
        
        setItems(updatedItems);
    }

    const HandleChangeClient = (e, name) => {
        let clientName = requestCreateNewClient.name;
        let orgNumber = requestCreateNewClient.orgNumber;
        let address = requestCreateNewClient.address;
        let postalCode = requestCreateNewClient.postalCode;
        let city = requestCreateNewClient.city;
        let email = requestCreateNewClient.email;

        if (name === "name") {
            clientName = e.target.value;
        }
        if (name === "orgNumber") {
              orgNumber = e.target.value;
        }
        if (name === "address") {
            address = e.target.value;
        }
        if (name === "postalCode") {
              postalCode = e.target.value;
        }
        if (name === "city") {
            city = e.target.value;
        }
        if (name === "email") {
            email = e.target.value;
        }

        setRequestCreateNewClient((prevFormData) => ({
            ...prevFormData,
            name: clientName,
            orgNumber: orgNumber,
            address: address,
            postalCode: postalCode,
            city: city,
            email: email,
        }));

    }

    const HandleChangeNewInvoice = (e, name) => {
        setIsDisabled(true);
        $("#buttonPreview").prop("disabled", true);
        let clientId = requestCreateInvoice.clientId;
        //let expiringDate = requestCreateInvoice.expiringDate;
        let recipientReference = requestCreateInvoice.recipientReference;
        //let reference = requestCreateInvoice.reference;
        let costBearerId = requestCreateInvoice.costBearerId;
        let status = requestCreateInvoice.status;
        let fileUrl = requestCreateInvoice.fileUrl;
        let rows = requestCreateInvoice.rows;

        if (name === "clientId") {
            clientId = e.value;
            setIdClient(e.value);
        }
        /*if (name === "expiringDate") {
            expiringDate = ChangeDateFormat('date', e);
        }*/
        if (name === "recipientReference") {
            recipientReference = e.target.value;
        }
        /*if (name === "reference") {
            reference = e.target.value;
        }*/
        if (name === "costBearerId") {

            costBearerId = e.target.value;
        }
        if (name === "fileUrl") {
            //VER COMO FUNCIONAR EL FILE URL
            fileUrl = e.target.value;
        }
        if (name === "rows") {
            //aqui hay que construir el array de las row
            rows = e.target.value;
        }

        setRequestCreateInvoice((prevFormData) => ({
            ...prevFormData,
            clientId: clientId,
            //expiringDate: expiringDate,
            recipientReference: recipientReference,
            //reference: reference,
            fileUrl: fileUrl,
            rows: rows,
            costBearerId:costBearerId,
        }));

    }

    const addRow = () =>{
        setItems((prevItems) =>{
            // Find the current maximum id
            const maxId = prevItems.reduce((max, item) => {
                const itemId = parseInt(item.id, 10); // Convert the id to a number
                return itemId > max ? itemId : max;
            }, 0);

            // Generate the new incremented id
            const newId = (maxId + 1).toString().padStart(1, '0'); // Ensure that the id has at least one digit
            //Create the new item
            const newItem = { id: newId, content: new RequestInvoiceRow() };

            return [...prevItems, newItem];
        })
        /*setItems((prevItems) =>{
            const newId = (prevItems.length + 1).toString();
            const newItem = { id: newId , content: requestCreateInvoiceRow};
            return [...prevItems,newItem]
        })*/
    }
    const deleteItem = (id) => {
        if (items.length <= 1) return;
        setIsDisabled(true);
        $("#buttonPreview").prop("disabled", true);
        const removeItems = items.filter(item => item.id !== id);
        setItems(removeItems);
    }

    const SaveDraft = async () => {
        //create the row array
        let rows = items.map(item => ClearEmptyJson(item.content));
        const cleanedRows = rows.filter(obj => Object.keys(obj).length > 0); //fiter empty objects

        if (cleanedRows.length === 0) {
            rows = null;
        } else {
            rows = cleanedRows;
        }
        
        if (responseCreateInvoice && responseCreateInvoice?.id !== '') {
            requestCreateInvoice.id = responseCreateInvoice.id;
        }
        requestCreateInvoice.rows = rows;
        requestCreateInvoice.status = 'Förslag'; //Draft

        setIsSave(true);
        const apiCallOptions = {
            method: "post",
            url: "/invoice",
            data: ClearEmptyJson(requestCreateInvoice),
        };
        try {
            await ApiCall(apiCallOptions, setResponseCreateInvoice);

        } catch (error) {
            console.log(error);
            FlashMessage(t('validationMessage.sendError'), 'flash-messageError');
            $("#sendAttest").prop("disabled", false);
            $("#buttonPreview").prop("disabled", false);
            $("#buttonSaveDraft").prop("disabled", false);
            setIsDisabled(false);
        }
    }

    useEffect(() => {
        if (responseCreateInvoice !== null) {
            switch (responseCreateInvoice.status) {
                case 'Förslag':
                    FlashMessage(t('validationMessage.invoiceSave'), 'flash-messageSuccess');
                    setDisplaySpinner(false);
                    setIsDisabled(false);
                    $("#sendAttest").prop("disabled", false);
                    $("#buttonPreview").prop("disabled", false);
                    $("#buttonSaveDraft").prop("disabled", false);
                    
                    if (id !== responseCreateInvoice.id) {
                        setTimeout(()=> {
                            window.location.href = `${ORGANIZATION_PATHS.INVOICE_CREATE}?id=${responseCreateInvoice.id}`;
                        },2000);
                    }
                    break;
                case 'Attestera kö':
                case 'Godkänd':
                    FlashMessage(t('validationMessage.invoiceSendToAttest'), 'flash-messageSuccess');

                    setTimeout(()=> {
                        navigate(ORGANIZATION_PATHS.INVOICE_LIST);
                    },2000);
                    break;
            }        
        }
    }, [responseCreateInvoice]);

    useEffect(() => {
        if (responseCreateNewClient !== '') {
            setTimeout(() => {
                setDisplaySpinnerClient(false);
                setDisplayAddNewClientModal(!displayAddNewClientModal);
                CustomReload(ORGANIZATION_PATHS.INVOICE_CREATE);
            },2000)
        }
    }, [responseCreateNewClient]);

   // let errorPrice = false;

   // const [flagSendAttest, setflagSendAttest] = useState(false);

    const SendAttest = async () => {
        //create the row array
        const rows = items.map(item => item.content);
        requestCreateInvoice.rows = rows;
        requestCreateInvoice.status = 'Attestera kö'; //AttestQueue
        try {

            await completeSchemaInvoice.validate(requestCreateInvoice, {abortEarly: false});
            let isError = false;
            requestCreateInvoice.rows.map(async (item) => {
                if (!item.product || item.price === 0 || item.quantity === 0) {
                    isError = true;
                }
                /*if (item.price === 0) {
                    setErrorPrice(true);
                } else {
                    setErrorPrice(false);
                }*/
                try {
                    await completeSchemaRows.validate(item, {abortEarly: false});
                } catch (error) {
                    console.log(error);
                }
            });

            if (responseCreateInvoice && responseCreateInvoice?.id !== '') {
                requestCreateInvoice.id = responseCreateInvoice.id;
            }
            if (requestCreateInvoice.id === ''){
                requestCreateInvoice.id = null;
            }
            if (requestCreateInvoice.visualId === ''){
                requestCreateInvoice.visualId = null;
            }
            if (requestCreateInvoice.fileUrl === ''){
                requestCreateInvoice.fileUrl = null;
            }
            if (isError === false &&  requestCreateInvoice.rows.length > 0) {
                setDisplaySpinner(true);
                const apiCallOptions = {
                    method: "post",
                    url: "/invoice",
                    data: requestCreateInvoice,
                };
                try {
                    await ApiCall(apiCallOptions, setResponseCreateInvoice);
                } catch (error) {
                   // $("#sendAttest").removeClass("disabled");
                    setDisplaySpinner(false);
                    console.log(error);
                    FlashMessage(t('validationMessage.sendError'), 'flash-messageError');
                    $("#sendAttest").prop("disabled", false);
                    $("#buttonPreview").prop("disabled", false);
                    $("#buttonSaveDraft").prop("disabled", false);
                }
            } /*else {
                $("#sendAttest").removeClass("disabled");
            }*/
        }catch (err) {
            console.log(err)
            $("#sendAttest").prop("disabled", false);
            $("#buttonPreview").prop("disabled", false);
            $("#buttonSaveDraft").prop("disabled", false);
        }
    }

    //CREATE CLIENT
    const handleValidationClient = async () => {
        try {
            if (requestCreateNewClient.orgNumber === '') {
                requestCreateNewClient.orgNumber = null;
            }
            if (requestCreateNewClient.address === '') {
                requestCreateNewClient.address = null;
            }
            if (requestCreateNewClient.postalCode === '') {
                requestCreateNewClient.postalCode = null;
            }
            if (requestCreateNewClient.city === '') {
                requestCreateNewClient.city = null;
            }
            await completeSchemaClient.validate(requestCreateNewClient, { abortEarly: false });
            $('#submitClient').prop('disabled', true);
            $('#cancelClient').prop('disabled', true);
            if (requestCreateNewClient && requestCreateNewClient.name !== "" &&  requestCreateNewClient.email !== "") {
                setDisplaySpinnerClient(true);
                const apiCallOptions = {
                    method: "post",
                    url: "/client",
                    data: requestCreateNewClient,
                };
                try {
                    await ApiCall(apiCallOptions, setResponseCreateNewClient);
                } catch (error) {
                    console.log(error);
                    FlashMessage(t('validationMessage.sendError'), 'flash-messageError');
                    $('#submitClient').prop('disabled', false);
                    $('#cancelClient').prop('disabled', false);
                }
            }
        } catch (err) {
            console.log(err)
            $('#submitClient').prop('disabled', false);
            $('#cancelClient').prop('disabled', false);
        }
    }

    // CLIENT ID
    useEffect(() => {
        const getDataClient = async () => {
            try {
                if (requestCreateNewClient && idClient !== null) {
                    const apiCallOptions = {
                        method: "get",
                        url: `/client?id=${idClient}`,
                    };
                    try {
                        await ApiCall(apiCallOptions, setGetClient);
                    } catch (error) {
                        console.log(error);
                        FlashMessage(t('validationMessage.sendError'), 'flash-messageError');
                    }
                }
            } catch (err) {
                console.log(err)
            }
        }
        getDataClient();
    }, [idClient]);



const previewInvoice = async () => {
        if (id !== '') {
            const apiCallOptions = {
                method: "get",
                url: `/invoice/pdf?id=${id}`,
            };
            try {
                await ApiCall(apiCallOptions, setPreviewPdf);
            } catch (error) {
                console.log(error);
            }
        }

}

    useEffect(() => {
        if (previewPdf !== null) {
            const DownloadTemporalFile = async () => {
                const handleDownloadApiResponse  = (response) => {
                    let file;
                    if (response instanceof Blob) {
                        file = response;

                    } else {
                        file = new Blob([response]);
                    }
                    const newFileName = generateFileName('invoice', visualId);
                    let fileName = newFileName;
                    const urlToFile = URL.createObjectURL(file);
                    const link = document.createElement('a');
                    link.href = urlToFile;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    setPreviewPdf(null);
                }
                const apiCallOptions = {
                    method: "get",
                    url: previewPdf,
                    dataTypes: 'blob',
                    responseType: 'blob'
                };
                try {
                    await ApiCall(apiCallOptions, (response) => handleDownloadApiResponse(response));
                } catch (error) {
                    console.log(error);
                }
            }
            DownloadTemporalFile()
        }
    }, [previewPdf]);


    //RENDER ROWS
    const RenderItem = (row) => {
        return (
            <>
                <Row key={'dragAndDrop' + row.id}>
                    <Col md={12}>
                        {windowWidth ? (
                            // Mobile layout: vertical with delete button on top right corner
                            <div className="border rounded p-3 mb-3">
                                <div className="d-flex justify-content-end">
                                    <button
                                        id={row.id}
                                        className="rounded border-0 py-1 text-red box-red p-custom-button class-deny"
                                        style={{...(items.length <= 1 ? { opacity: 0.35, cursor: 'not-allowed' } : {}) }}
                                        onClick={() => deleteItem(row.id)}
                                        disabled={items.length <= 1}
                                    >
                                        <i className="bx bx-trash-alt py-1 align-middle size-icon-custom-button" />
                                    </button>
                                </div>
                                <Row>
                                    <Col xs={12} className="mb-2">
                                        <small className="text-muted">{t('modelLabel.product')}</small>
                                        <CustomInput model={RequestInvoiceRow} attribute='product' data={row.content.product} customOptions={productJson} customChange={(e) => HandleChangeInvoiceRow(e, 'product', row.id)}/>
                                    </Col>
                                    <Col xs={12} className="mb-2">
                                        <small className="text-muted">{t('modelLabel.description')}</small>
                                        <CustomInput model={RequestInvoiceRow} attribute='name' data={row.content.name} customChange={(e) => HandleChangeInvoiceRow(e, 'name', row.id)}/>
                                    </Col>
                                    <Col xs={6} className="mb-2">
                                        <small className="text-muted">{t('invoice.quantity')}</small>
                                        <div className="input-text-right">
                                            <CustomInput model={RequestInvoiceRow} attribute='quantity' data={row.content.quantity} customChange={(e) => HandleChangeInvoiceRow(e, 'quantity', row.id)}/>
                                        </div>
                                    </Col>
                                    <Col xs={6} className="mb-2">
                                        <small className="text-muted">{t('invoice.unitPrice')}</small>
                                        <div className="input-text-right">
                                            <CustomInput model={RequestInvoiceRow} attribute='price' data={row.content.price} customOptions={productsResponse} customChange={(e) => HandleChangeInvoiceRow(e, 'price', row.id)}/>
                                        </div>
                                    </Col>
                                    <Col xs={12}>
                                        <small className="text-muted">{t('modelLabel.total')}</small>
                                        <div className="bg-grey-tab rounded py-1 border px-3 text-end">
                                            {ToCustomDecimal(((Number(row.content.quantity) || 0) * (Number(row.content.price) || 0)) + (parseFloat(row.content.vatAmount) || 0))} kr
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        ) : (
                            // DESKTOP: layout in a row with delete button on the right end
                            <>
                                <Row className="align-items-stretch">
                                    <Col xs={3}>
                                        <CustomInput model={RequestInvoiceRow} attribute='product' data={row.content.product} customOptions={productJson} customChange={(e) => HandleChangeInvoiceRow(e, 'product', row.id)}/>
                                    </Col>
                                    <Col xs={3}>
                                        <CustomInput model={RequestInvoiceRow} attribute='name' data={row.content.name} customChange={(e) => HandleChangeInvoiceRow(e, 'name', row.id)}/>
                                    </Col>
                                    <Col xs={1}>
                                        <div className="input-text-right">
                                            <CustomInput model={RequestInvoiceRow} attribute='quantity' data={row.content.quantity} customChange={(e) => HandleChangeInvoiceRow(e, 'quantity', row.id)}/>
                                        </div>
                                    </Col>
                                    <Col xs={2}>
                                        <div className="input-text-right">
                                            <CustomInput model={RequestInvoiceRow} attribute='price' data={row.content.price} customOptions={productsResponse} customChange={(e) => HandleChangeInvoiceRow(e, 'price', row.id)}/>
                                        </div>
                                    </Col>
                                    <Col xs={2} className="d-flex align-items-center">
                                        <div className="bg-grey-tab rounded py-1 border text-end w-100 px-3">
                                            {ToCustomDecimal(((Number(row.content.quantity) || 0) * (Number(row.content.price) || 0)) + (parseFloat(row.content.vatAmount) || 0))} kr
                                        </div>
                                    </Col>
                                    <Col xs={1} className="d-flex align-items-center justify-content-center">
                                        <button
                                            id={row.id}
                                            className="rounded me-2 border-0 py-1 text-red box-red p-custom-button position-relative class-deny"
                                            onClick={() => deleteItem(row.id)}
                                            disabled={items.length <= 1}
                                            style={items.length <= 1 ? { opacity: 0.35, cursor: 'not-allowed' } : {}}
                                        >
                                            <i className="bx bx-trash-alt py-1 align-middle size-icon-custom-button" />
                                            <div className="tooltip-custom-button">{t('button.delete')}</div>
                                        </button>
                                    </Col>
                                </Row>
                                <hr />
                            </>
                        )}
                    </Col>
                </Row>
            </>
        );
    };

    //MODAL CONTENT

    const modalContent = (
        <div ref={formDivRefClient}>
            <h4 className="rokkitt-font">{t('invoice.addClient')}</h4>
            <Row>
                <Col lg={10} className='mx-auto'>
                    <CustomInput model={RequestClient} attribute='name' data={requestCreateNewClient.name} customChange={(e) => HandleChangeClient(e, 'name')}/>
                    <CustomInput model={RequestClient} attribute='orgNumber' data={requestCreateNewClient.orgNumber} customChange={(e) => HandleChangeClient(e, 'orgNumber')}/>
                    <CustomInput model={RequestClient} attribute='address' data={requestCreateNewClient.address} customChange={(e) => HandleChangeClient(e, 'address')}/>
                    <CustomInput model={RequestClient} attribute='postalCode' data={requestCreateNewClient.postalCode} customChange={(e) => HandleChangeClient(e, 'postalCode')}/>
                    <CustomInput model={RequestClient} attribute='city' data={requestCreateNewClient.city} customChange={(e) => HandleChangeClient(e, 'city')}/>
                    <CustomInput model={RequestClient} attribute='email' data={requestCreateNewClient.email} customChange={(e) => HandleChangeClient(e, 'email')}/>
                    <div className="text-green d-flex align-items-center mb-3">
                         <i className='bx bx-info-circle fs-5 pe-2'/>* obligatoriskt fält
                    </div>
                </Col>
            </Row>
            {displaySpinnerClient === true ?
                <>
                    {t('validationMessage.savingClient')} <Spinner color='success'/>
                </>
                : ''}
        </div>
    );

    const modalFooter = (
        <>
            <CustomSubmitButton text={t('invoice.addClient')} className="box-green border-0" id="submitClient" formDivRef={formDivRefClient} customClick={() => {
                handleValidationClient();
               // setDisplaySpinnerClient(true);

            }}/>
            <Button id="cancelClient" className="box-red border-0" onClick={() => setDisplayAddNewClientModal(false)}>{t('button.cancel')}</Button>
        </>
    );

    return(
        <>
        {permissionCreateInvoice !== true ? '' :
            !windowWidth && (
                <Col lg={12} className="px-0">
                    <CustomButton
                        text={t('button.back')}
                        icon={'bx bx-chevron-left'}
                        buttonSize={'small'}
                        customClasses={'mb-3 ms-3 backButton'}
                        onClick={() => {
                            navigate(ORGANIZATION_PATHS.INVOICE_LIST)
                        }}
                    />
                </Col>
            )
        }
            <Col lg={12} className="pb-5 px-0 mx-0">
                <CustomModal 
                    isOpen={displayAddNewClientModal} 
                    toggle={() => setDisplayAddNewClientModal(!displayAddNewClientModal)}
                    body={modalContent} 
                    footer={modalFooter}
                />
                <Card className="card-backend p-4">
                    <Row>
                        <Col xs='auto'>
                            <h2 className='rokkitt-font'>{t('invoice.createInvoice')}</h2>
                        </Col>
                        <InfoPageMessage message={t('infoBox.createInvoice')}/>
                    </Row>
                    <Row>
                        <Col lg={12}>
                            <Row>
                                <Col lg={permissionCreate === true ? 5 : 7} className="order-1 order-lg-0">
                                    {permissionViewClient === true ? (
                                        <CustomInput 
                                            model={RequestInvoice}  
                                            attribute='clientId' 
                                            data={requestCreateInvoice.clientId} 
                                            customChange={(e) => HandleChangeNewInvoice(e, 'clientId')} 
                                            customOptions={clientJson}
                                        />
                                    ) : (
                                        <div className="box-red align-self-center py-3">
                                            <i className="bx bx-info-circle fs-4 text-red me-3 align-middle"/>
                                            {t('validationMessage.clientPermission')}
                                        </div>
                                    )}
                                </Col>
                                
                                {permissionCreate === true && (
                                    <Col lg={7} className="d-flex justify-content-center order-0 order-lg-1 pt-2">
                                        <CustomButton 
                                            customClasses="align-self-center p-2 me-2" 
                                            icon={"bx bx-plus"} 
                                            text={t('invoice.addClient')} 
                                            onClick={() => setDisplayAddNewClientModal(true)} 
                                        />
                                    </Col>
                                )}
                            </Row>               
                            {getClient !== null ?
                                    <div ref={formDivRefInvoice}>
                                        {costResponse !== null && getClient !== null ?
                                        <Row  className="border-bottom pb-4">                                     
                                            <Col lg={4}>
                                                <CustomInput model={RequestInvoice}  attribute='costBearerId' data={requestCreateInvoice.costBearerId} customChange={(e) => HandleChangeNewInvoice(e, 'costBearerId')} customOptions={costJson}/>
                                                {messageCostBearer}
                                            </Col>
                                                            
                                        </Row>
                                        : ''}
                                        <Row className="pt-4">
                                        <Col lg={3}>
                                                {getClient !== null && userData !== null ?
                                                    <>
                                                        <div className="fw-bold pb-2">Vår referens</div>
                                                        <div className="border rounded pt-3 px-3 bg-card-grey" style={{ minHeight: '130px' }}>
                                                            <ul className='list-unstyled pb-0'>
                                                                {apiResponseOrgInfo?.name ?
                                                                    <li>
                                                                        {`${apiResponseOrgInfo.name} - ${apiResponseOrgInfo.type ? apiResponseOrgInfo.type : ''}`}
                                                                    </li>
                                                                    :''}
                                                                {userData.firstName ?
                                                                    <li>{`${userData.firstName} ${userData.lastName ? userData.lastName : ''}`}</li>
                                                                    :''}
                                                                {userData.phone ?
                                                                    <li>{`${userData.phone}`}</li>
                                                                    :''}
                                                                {userData.email ?
                                                                    <li>{`${userData.email}`}</li>
                                                                    :''}
                                                            </ul>
                                                        </div>
                                                    </>
                                                    : ''}

                                            </Col>
                                            <Col lg={3}>                               
                                                {getClient !== null ?
                                                    <>
                                                        <div className="fw-bold pb-2">{t('invoice.invoiceRecipient')}</div>
                                                        <div className="border rounded pt-3 px-3 bg-card-grey" style={{ minHeight: '130px' }}>
                                                            <ul className='list-unstyled pb-0'>
                                                                {getClient.orgNumber ?
                                                                    <li>
                                                                        {/* <span>{t('modelLabel.orgNumber')}: </span> */}
                                                                        {`${getClient.name} - ${getClient.orgNumber}`}
                                                                    </li>
                                                                    :
                                                                    <li>
                                                                        {`${getClient.name}`}
                                                                    </li>
                                                                }
                                                                {getClient.address ?
                                                                    <li>{getClient.address}</li>
                                                                    :''}
                                                                {getClient.postalCode ?
                                                                    <li>{`${getClient.postalCode} ${getClient.city ? getClient.city : ''}`}</li>
                                                                    :''}
                                                                {/* {getClient.city ?
                                                                    <li>{getClient.city}</li>
                                                                    :''} */}
                                                                <li>{getClient.email}</li>
                                                            </ul>
                                                        </div>
                                                    </>
                                                    : ''}

                                            </Col>
                                        </Row>
                                        <Row className="pt-4">
                                            {/* <Col lg={3}>
                                                <label className="mb-2">
                                                    {t('modelLabel.createdAt')}:
                                                </label>
                                                <input type="text" className="form-control" readOnly={true} value={requestCreateInvoice.createdAt ? ChangeDateFormat("date", requestCreateInvoice.createdAt) : ChangeDateFormat("date", new Date()) }/>
                                            </Col> */}
                                            <Col lg={3}>
                                                <CustomInput model={RequestInvoice}  attribute='recipientReference' data={requestCreateInvoice.recipientReference} customChange={(e) => HandleChangeNewInvoice(e, 'recipientReference')}/>
                                            </Col>
                                            {/*<Col lg={3}>
                                                <CustomInput model={RequestInvoice}  attribute='expiringDate' data={requestCreateInvoice.expiringDate} customChange={(e) => HandleChangeNewInvoice(e, 'expiringDate')}/>
                                            </Col>                                        
                                            <Col lg={3}>
                                                <CustomInput model={RequestInvoice}  attribute='reference' data={requestCreateInvoice.reference} customChange={(e) => HandleChangeNewInvoice(e, 'reference')}/>
                                            </Col>*/}
                                        </Row>
                                        <Row  className="pt-4">
                                            <Col lg={12}>
                                                <h4>{t('invoice.invoiceRow')}</h4>
                                            </Col>
                                            {windowWidth ? <hr/> : ''}
                                            <Col lg={12}>
                                                {windowWidth ? '' :
                                                    <Row className="bg-card-grey py-2 mb-2">
                                                        <Col xs={3}>{t('modelLabel.product')}</Col>
                                                        <Col xs={3}>{t('modelLabel.description')}</Col>
                                                        <Col xs={1}>{t('invoice.quantity')}</Col>
                                                        <Col xs={2}>{t('invoice.unitPrice')}</Col>
                                                        <Col xs={2} className="text-end">{t('modelLabel.total')}</Col>
                                                        <Col xs={1}></Col>
                                                    </Row>
                                                }
                                                <DragAndDrop items={items}  droppableId="droppable" onDragEnd={handleDragEnd}  renderItem={RenderItem} side="vertical"/>
                                            </Col>
                                            <Col lg={12} className="mb-2">
                                                <CustomButton text={t('invoice.addInvoiceRow')} icon={"bx bx-plus pe-1"} customClasses="bg-secondary" onClick={() => addRow()}/>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={12} lg={3} className="offset-lg-9">
                                                <Row>
                                                    <Col lg={6}>
                                                        {t('modelLabel.amountInvoice')}
                                                    </Col>
                                                    <Col lg={6} className="bg-grey-tab mb-2 rounded py-1 text-end">
                                                        {productsTotalAmount?.amount ? ToCustomDecimal(productsTotalAmount.amount) +' kr' : '0 kr'}
                                                    </Col>
                                                    <Col lg={6}>
                                                        {t('modelLabel.vatAmountInvoice')}
                                                    </Col>
                                                    <Col lg={6} className="bg-grey-tab mb-2 rounded py-1 text-end">
                                                        {productsTotalAmount?.vatAmount ? ToCustomDecimal(productsTotalAmount.vatAmount) +' kr' : '0 kr'}
                                                    </Col>
                                                    <Col lg={6}>
                                                        {t('modelLabel.total')}
                                                    </Col>
                                                    <Col lg={6} className="bg-grey-tab mb-2 rounded py-1 text-end">
                                                        {productsTotalAmount?.totalAmount ? ToCustomDecimal(productsTotalAmount.totalAmount) +' kr' : '0 kr'}
                                                    </Col>
                                                </Row>

                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg={7} className="text-center">
                                                {displaySpinner === true ?
                                                    <>
                                                        {isSave === true ? t('validationMessage.savingInvoice') : t('validationMessage.sendingInvoice')} <Spinner color='success'/>
                                                    </>
                                                    : ''}
                                            </Col>
                                            <Col lg={5} className="pt-4">
                                                <div className="d-flex justify-content-end">
                                                    <div onMouseEnter={handleMouseEnter}
                                                         onMouseLeave={handleMouseLeave} className="me-2">
                                                        <Button  id="buttonPreview" disabled={id === '' ? true : false }
                                                                 onClick={() => {
                                                                     previewInvoice()
                                                                 }}
                                                                 className="btn-submit-kassan border-0 position-relative">
                                                            {t('invoice.previewInvoice')}
                                                            <div className={`tooltip-grey-pdf  ${isDisabled && isMouseOver === true ? 'opacity-1' : ''}`}>{t('validationMessage.needSave')} </div>
                                                        </Button>
                                                    </div>

                                                    <Button id="buttonSaveDraft" className="border-0 btn-submit-kassan me-2" onClick ={()=>{
                                                        SaveDraft();
                                                        setDisplaySpinner(true);
                                                        setIsDisabled(true);
                                                        $("#sendAttest").prop("disabled", true);
                                                        $("#buttonPreview").prop("disabled", true);
                                                        $("#buttonSaveDraft").prop("disabled", true);
                                                    }}>
                                                        <i className="bx bx-save pe-2 pt-1"/>
                                                        {t('invoice.draft')}
                                                    </Button>

                                                    <CustomSubmitButton text={t('button.sendToAttest')} icon="bx bx-send pe-2" id="sendAttest" customClass="btn-submit-kassan" formDivRef={formDivRefInvoice} customClick={()=>{
                                                        SendAttest();
                                                        $("#sendAttest").prop("disabled", true);
                                                        $("#buttonPreview").prop("disabled", true);
                                                        $("#buttonSaveDraft").prop("disabled", true);
                                                        setIsDisabled(true);
                                                    }}/>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    : ''
                            }

                        </Col>
                    </Row>
                </Card>
            </Col>

        </>


    )
    
}